export interface RoadmapTeam {
	id: string
	name: string
	ids: string[]
}

export function groupTeamsByName(
	teams: Array<{ id: string; name: string }>,
): RoadmapTeam[] {
	const byName = new Map<string, string[]>()
	for (const { id, name } of teams) {
		const ids = byName.get(name)
		if (ids) {
			if (!ids.includes(id)) ids.push(id)
		} else {
			byName.set(name, [id])
		}
	}
	return Array.from(byName.entries())
		.map(([name, ids]) => ({ id: ids[0]!, name, ids }))
		.sort((a, b) => a.name.localeCompare(b.name))
}

export function isTeamSelected(team: RoadmapTeam, selectedIds: string[]) {
	return team.ids.some((id) => selectedIds.includes(id))
}

// The filter stores one id per team name, so widen it to every Linear team
// sharing that name before querying.
export function expandTeamIds(teams: RoadmapTeam[], selectedIds: string[]) {
	const expanded = selectedIds.flatMap(
		(id) => teams.find((team) => team.ids.includes(id))?.ids ?? [id],
	)
	return Array.from(new Set(expanded))
}

/**
 * A project carries its own teams, and its issues can sit in other teams or not
 * exist at all, so the team gate reads the project row.
 */
export function projectMatchesTeams(
	project: { linearTeamIds?: readonly string[] | string[] | null },
	teamIds: readonly string[],
): boolean {
	if (teamIds.length === 0) return true
	return !!project.linearTeamIds?.some((id) => teamIds.includes(id))
}
